import useAccordion from "@components/Accordion/useAccordion";
import AccordionContext from "@components/Accordion/accordionContext";

const Accordion = ({ mode, expandedItems, onToggle, children }) => {
  const { isItemExpanded, isItemToggleable, onItemToggle } = useAccordion({
    mode,
    expandedItems,
    onToggle,
  });

  return (
    <AccordionContext.Provider
      value={{
        isItemExpanded,
        isItemToggleable,
        onItemToggle,
      }}
    >
      {children}
    </AccordionContext.Provider>
  );
};

export default Accordion;
